export const locationData = [
  { value: 'FR', label_en: 'France', label_de: 'Frankreich' },
  { value: 'ES', label_en: 'Spain', label_de: 'Spanien' },
  { value: 'PT', label_en: 'Portugal', label_de: 'Portugal' },
  { value: 'SE', label_en: 'Sweden', label_de: 'Schweden' },
  { value: 'BG', label_en: 'Bulgaria', label_de: 'Bulgarien' },
  { value: 'HR', label_en: 'Croatia', label_de: 'Kroatien' },
  { value: 'CZ', label_en: 'Czech Republic', label_de: 'Tschechien' },
  { value: 'DK', label_en: 'Denmark', label_de: 'Dänemark' },
  { value: 'EE', label_en: 'Estonia', label_de: 'Estland' },
  { value: 'FI', label_en: 'Finland', label_de: 'Finnland' },
  { value: 'GR', label_en: 'Greece', label_de: 'Griechenland' },
  { value: 'GB', label_en: 'United Kingdom', label_de: 'Vereinigtes Königreich' },
  { value: 'HU', label_en: 'Hungary', label_de: 'Ungarn' },
  { value: 'IE', label_en: 'Ireland', label_de: 'Irland' },
  { value: 'LV', label_en: 'Latvia', label_de: 'Lettland' },
  { value: 'LT', label_en: 'Lithuania', label_de: 'Litauen' },
  { value: 'MK', label_en: 'North Macedonia', label_de: 'Nordmazedonien' },
  { value: 'NO', label_en: 'Norway', label_de: 'Norwegen' },
  { value: 'PL', label_en: 'Poland', label_de: 'Polen' },
  { value: 'RO', label_en: 'Romania', label_de: 'Rumänien' },
  { value: 'RS', label_en: 'Serbia', label_de: 'Serbien' },
  { value: 'DE', label_en: 'Germany', label_de: 'Deutschland' },
  { value: 'BE', label_en: 'Belgium', label_de: 'Belgien' },
  { value: 'NL', label_en: 'Netherlands', label_de: 'Niederlande' },
  { value: 'SI', label_en: 'Slovenia', label_de: 'Slowenien' },
  { value: 'SK', label_en: 'Slovakia', label_de: 'Slowakei' },
  { value: 'IT', label_en: 'Italy', label_de: 'Italien' },
  { value: 'AT', label_en: 'Austria', label_de: 'Österreich' },
  { value: 'LU', label_en: 'Luxembourg', label_de: 'Luxemburg' },
  { value: 'CH', label_en: 'Switzerland', label_de: 'Schweiz' },
  { value: 'TR', label_en: 'Turkey', label_de: 'Türkei' },
  { value: 'ME', label_en: 'Montenegro', label_de: 'Montenegro' },
  { value: 'BA', label_en: 'Bosnia and Herzegovina', label_de: 'Bosnien und Herzegowina' },
];

const locationMap = new Map(locationData.map((loc) => [loc.value, loc]));

export function getLocationLabel(value?: string, lang: string = 'en'): string | undefined {
  if (!value) return undefined;
  const loc = locationMap.get(value);
  if (!loc) return undefined;

  return lang === 'de' ? loc.label_de : loc.label_en;
}

export function getLocalizedLocationData(lang: string = 'en') {
  return locationData.map((loc) => ({
    value: loc.value,
    label: lang === 'de' ? loc.label_de : loc.label_en,
  }));
}
